import { createFetcher, CacheMode } from 'create-fetcher';
import { config } from './config';
/**
 * cache proxy to config cache, use this cache for manual created fetcher
 */
export const defaultCache = {
    get(key) {
        return config.cache.get(key);
    },
    set(key, value) {
        return config.cache.set(key, value);
    },
    getKeys() {
        return config.cache.getKeys();
    },
    remove(key) {
        return config.cache.remove(key);
    },
    clear() {
        return config.cache.clear();
    },
};
const noCacheFetcherByAPIMethod = new Map();
/**
 * wrap api method into a no cache fetcher - to use together with hooks
 * @deprecated NOTE: 在使用这个方法前请先考虑使用pb里的CacheControl定义, mode: CACHE_MODE_NO_STORE 可以达到同样的效果, 只有在不是直接使用interface包里的api的情况下才需要用到这个方法
 */
export function wrapNoCacheFetcher(apiMethod) {
    if (noCacheFetcherByAPIMethod.has(apiMethod)) {
        return noCacheFetcherByAPIMethod.get(apiMethod);
    }
    const fetcher = createFetcher(apiMethod, {
        cacheMode: CacheMode.NoStore,
    });
    noCacheFetcherByAPIMethod.set(apiMethod, fetcher);
    return fetcher;
}
